import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=89121abc&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports